import { useState } from 'react';
import { useSelector } from 'react-redux';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import UserLoopSelectorContainer from 'pages/Remixer/components/UserLoopSelectorContainer';
import {
  checkCurrentSongLoading,
  selectUserLoop,
} from 'services/store/remixer/selectors';
import DeleteUserLoopDialog from '../DeleteUserLoopDialog/DeleteUserLoopDialog';
import {
  StyledContainer,
  StyledButton,
  StyledIconWrapper,
  StyledStateTypography,
} from './styled';

const FileInfoContainer = () => {
  const isLoading = useSelector(checkCurrentSongLoading);

  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const userLoop = useSelector(selectUserLoop);
  const loopFileName = userLoop?.loopFileName;

  const openEditDialog = () => setIsEditDialogOpen(true);
  const closeEditDialog = () => setIsEditDialogOpen(false);

  const openDeleteDialog = () => setIsDeleteDialogOpen(true);
  const closeDeleteDialog = () => setIsDeleteDialogOpen(false);

  if (!userLoop) {
    return null;
  }

  return (
    <>
      <StyledContainer>
        <StyledStateTypography disabled={isLoading}>
          {loopFileName}
        </StyledStateTypography>
        <StyledIconWrapper>
          <StyledButton
            disableRipple
            disabled={isLoading}
            startIcon={<SettingsIcon />}
            onClick={openEditDialog}
          />
          <StyledButton
            disableRipple
            disabled={isLoading}
            startIcon={<DeleteIcon />}
            onClick={openDeleteDialog}
          />
        </StyledIconWrapper>
      </StyledContainer>

      <UserLoopSelectorContainer
        isOpen={isEditDialogOpen}
        onClose={closeEditDialog}
        data={userLoop}
      />

      <DeleteUserLoopDialog
        isOpen={isDeleteDialogOpen}
        onClose={closeDeleteDialog}
        data={userLoop}
      />
    </>
  );
};

export default FileInfoContainer;
